<template>
  <div class="row filterBar__inner">
    <div id="searchParamsTrigger">{{ searchParams }}</div>
    <div class="col-lg">
      <label
        >{{ this.$store.state.miscData.miscData.BranchDropdownLabel }}:</label
      >
      <b-form-select
        class="select"
        v-model="selectedBranch"
        :options="this.$store.getters.branchesOptions"
        id="selectedBranch"
      ></b-form-select>
    </div>
    <div class="col-lg">
      <label
        >{{ this.$store.state.miscData.miscData.LocatieDropdownLabel }}:</label
      >
      <b-form-select
        class="select filterSelect"
        v-model="selectedLocation"
        :options="this.$store.getters.locationsOptions"
        id="selectedLocation"
      ></b-form-select>
    </div>
    <div class="col-lg">
      <label
        >{{ this.$store.state.miscData.miscData.ServiceDropdownLabel }}:</label
      >
      <b-form-select
        class="select filterSelect"
        v-model="selectedService"
        :options="this.$store.getters.servicesOptions"
        id="selectedService"
      ></b-form-select>
    </div>
    <div class="col-lg">
      <label
        >{{
          this.$store.state.miscData.miscData.ProductgroepDropdownLabel
        }}:</label
      >
      <b-form-select
        class="select filterSelect"
        v-model="selectedProductGroup"
        :options="this.$store.getters.productGroupsOptions"
        id="selectedProductGroup"
      ></b-form-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductBoard",
  data() {
    return {
      searchParamsToggle: false,
    };
  },
  computed: {
    searchParams: function() {
      let searchParams = new URLSearchParams();

      if (this.searchParamsToggle) {
        let selectedFiltersDictionary = new Object();

        selectedFiltersDictionary = {
          selectedBranch: this.$store.state.products.selectedBranch,
          selectedLocation: this.$store.state.products.selectedLocation,
          selectedService: this.$store.state.products.selectedService,
          selectedProductGroup: this.$store.state.products.selectedProductGroup,
        };

        for (const selectedProperty in selectedFiltersDictionary) {
          let value = selectedFiltersDictionary[selectedProperty];
          if (value != null) {
            searchParams.append(selectedProperty, value);
          }
        }

        var questionMark = "";
        for (var value of searchParams.values()) {
          questionMark = "?";
        }

        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          questionMark +
          searchParams;
        window.history.pushState({ path: newurl }, "", newurl);
      }

      return searchParams;
    },
    selectedBranch: {
      get() {
        return this.$store.state.products.selectedBranch;
      },
      set(value) {
        this.$store.commit("selectedBranch", value);
        if (value == null) {
          this.$store.commit("selectedBranch", null);
        }
      },
    },

    selectedLocation: {
      get() {
        return this.$store.state.products.selectedLocation;
      },
      set(value) {
        this.$store.commit("selectedLocation", value);
        if (value == null) {
          this.$store.commit("selectedLocation", null);
        }
      },
    },

    selectedService: {
      get() {
        return this.$store.state.products.selectedService;
      },
      set(value) {
        this.$store.commit("selectedService", value);
        if (value == null) {
          this.$store.commit("selectedService", null);
        }
      },
    },

    selectedProductGroup: {
      get() {
        return this.$store.state.products.selectedProductGroup;
      },
      set(value) {
        this.$store.commit("selectedProductGroup", value);
        if (value == null) {
          this.$store.commit("selectedProductGroup", null);
        }
      },
    },
  },
  mounted() {
    let searchParams = new URLSearchParams(window.location.search);

    let selectedBranch = searchParams.get("selectedBranch");
    this.$store.commit("selectedBranch", selectedBranch);

    let selectedLocation = searchParams.get("selectedLocation");
    this.$store.commit("selectedLocation", selectedLocation);

    let selectedService = searchParams.get("selectedService");
    this.$store.commit("selectedService", selectedService);

    let selectedProductGroup = searchParams.get("selectedProductGroup");
    this.$store.commit("selectedProductGroup", selectedProductGroup);

    this.searchParamsToggle = true;
    //debugger;
  },
};
</script>

<style lang="scss">
#searchParamsTrigger {
  display: none;
}
#filterBar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media only screen and (max-width: 900px) {
    flex-direction: column;
  }

  .selectDiv {
    display: flex;
    flex-direction: column;
    width: 23%;

    @media only screen and (max-width: 900px) {
      width: 100%;
    }
  }
}
</style>
